import { Platform, StyleSheet, ViewStyle } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space4, space6, colorBgBase, shadowColor } = theme();

  return StyleSheet.create({
    footer: {
      alignItems: "center",
      bottom: 0,
      backgroundColor: colorBgBase,
      width: "100%",
      flexDirection: "column",
      paddingHorizontal: space6,
      paddingVertical: space4,
      shadowColor: shadowColor,
      shadowOpacity: 0.15,
      ...Platform.select({
        web: {
          position: "sticky",
          shadowOffset: {
            width: 0,
            height: 8,
          },
          shadowRadius: 18,
          elevation: 0.5,
        },
        ios: { position: "absolute" },
        android: { position: "absolute" },
      }),
    } as ViewStyle,
  });
};

export { style };
